import * as Yup from "yup";

export const validationSchema = Yup.object({
    endpointUrl: Yup
        .string()
        .required("Required"),
    username: Yup
        .string()
        .required("Required"),
    password: Yup
        .string()
        .required("Required"),
    type: Yup
        .string()
        .required("Required"),
    sendId: Yup
        .string()
        .required("Required"),
    
})

export const initialValues = {
    endpointUrl: "",
    username: "",
    password: "",
    type: "",
    sendId: "",
}